import { Box } from "@mui/material";

import { Tabs } from "@/modules/common/components/Tabs";
import { PlayBox } from "@/modules/play/Components";
import { PlayerHeaderGrid } from "@/modules/play/PlayerPersona/PlayerHeaderGrid";
import { PlayerPageLayout } from "@/modules/play/PlayLayout/PlayerPageLayout";
import { useTranslation } from "@/modules/translations/useTranslation";

import { SynthesisAchievementsTab } from "./SynthesisAchievementsTab";
import { SynthesisScenarioName } from "./SynthesisContent";
import { SynthesisGeneralTab } from "./SynthesisGeneralTab";
import { SynthesisMostImpactfulActionsTab } from "./SynthesisMostImpactfulActionsTab";

export { SynthesisPage };

function SynthesisPage() {
  return <SynthesisLayout />;
}

function SynthesisLayout() {
  const { t } = useTranslation();

  return (
    <PlayerPageLayout
      header={<PlayerHeaderGrid />}
      body={
        <Box display="flex" flexDirection="column" gap={2}>
          <PlayBox display="flex" flexDirection="column" gap={4}>
            <SynthesisScenarioName />
          </PlayBox>
          <Box>
            <Tabs
              tabs={[
                {
                  label: t("synthesis.player.general-section.title"),
                  iconName: "chart-pie",
                  component: <SynthesisGeneralTab />,
                },
                {
                  label: t(
                    "synthesis.player.most-impactful-actions-section.title",
                  ),
                  iconName: "impactful",
                  component: <SynthesisMostImpactfulActionsTab />,
                },
                {
                  label: t("synthesis.player.achievements-section.title"),
                  iconName: "trophy",
                  component: <SynthesisAchievementsTab />,
                },
              ]}
            />
          </Box>
        </Box>
      }
    />
  );
}
